
/**
 * 링크 유형 (외부 링크 또는 프로젝트 링크)
 */
export type ExploreContentResponsePageAllOfThreeContentItemContentOneOfMediaLinksItemLinkType = typeof ExploreContentResponsePageAllOfThreeContentItemContentOneOfMediaLinksItemLinkType[keyof typeof ExploreContentResponsePageAllOfThreeContentItemContentOneOfMediaLinksItemLinkType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExploreContentResponsePageAllOfThreeContentItemContentOneOfMediaLinksItemLinkType = {
  EXTERNAL: 'EXTERNAL',
  PROJECT: 'PROJECT',
} as const;
